export enum AutomationConditionErrorsType {
  EmptyCondition = 'emptyCondition',
  EmptyOrganizer = 'emptyOrganizer',
  EmptyPreferredLocation = 'emptyPreferredLocation',
  EmptyLocation = 'emptyLocation',
  EmptyDepartment = 'emptyDepartment',
  EmptyRecruiter = 'emptyRecruiter',
  EmptyHiringManager = 'emptyHiringManager',
  EmptyTags = 'emptyTags',
  EmptyInterviewers = 'emptyInterviewers',
  EmptyAssignees = 'emptyAssignees',
  EmptyWorkModel = 'emptyWorkModel',
  EmptyCreator = 'emptyCreator',
  EmptyPreviousStatus = 'emptyPreviousStatus',
  EmptySourceTags = 'emptySourceTags',
  EmptyOrigin = 'emptyOrigin',
  EmptyFromStage = 'emptyFromStage',
  EmptyTimeFrame = 'emptyTimeFrame',
  EmptyWithin = 'emptyWithin',
  NotNumberWithin = 'notNumberWithin',
  NotIntegerWithin = 'notIntegerWithin',
  NotGraterThanZeroWithin = 'notGraterThanZeroWithin',
  EmptyPeriod = 'emptyPeriod',
  EmptyDateFrom = 'emptyDateFrom',
  EmptyDateTo = 'emptyDateTo',
  EmptyDate = 'emptyDate',
  EmptyRating = 'emptyRating',
  EmptyStage = 'emptyStage',
  EmptyAssignedTo = 'emptyAssignedTo',
}
